export default "__VITE_ASSET__DRLENE8p__"